import { useState } from "react";

import { VirtualSiteGroupEditForm } from "src/app/features/VirtualSiteGroup/components/forms/VirtualSiteGroupEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const VirtualSiteGroupEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.VIRTUAL_SITE_GROUPS, "basicTabsWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.VirtualSiteGroupEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.VIRTUAL_SITE_GROUPS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <VirtualSiteGroupEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
